import * as React from "react";

import "./multi-select-footer.scss";

import {makeChain} from "@Common/react/cst2";
import {Types}     from "@Common/types";


export const MultiSelectFooter = ({
    maxSelections,
    numSelected,
    onApply,
    onClear,
}:{
    maxSelections  : number,
    numSelected    : number,
    onApply        : () => void,
    onClear        : Types.Common.UiComponents.PhotoDashboard.Functions.OnClearMultiSelectSelections,
}) => (

    makeChain<JSX.Element>()

    // render the component
    .then(() => (
        <div className="multi-select-footer-t93 footer">
            <p>
                {numSelected} of {maxSelections} photo{maxSelections !== 1 && "s"} will be imported
                {!!numSelected && (
                <button className="clear"
                    xd-qa-type="button" xd-qa-name="ccgallery multiselect clear"
                    onClick={onClear}
                >Clear Selection</button>
                )}
            </p>
            <button className="import"
                xd-qa-type="button" xd-qa-name="ccgallery multiselect apply"
                disabled={!numSelected}
                onClick={onApply}
            >Import</button>
        </div>
    ))

    .run()

);